
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.234 5.647c.263.635.447 1.312.54 2.017l-.497.065a7.579 7.579 0 010 1.96l.496.065a7.946 7.946 0 01-.54 2.017l-.461-.191a7.49 7.49 0 01-.98 1.695l.396.304a8.048 8.048 0 01-1.477 1.477l-.305-.396a7.485 7.485 0 01-1.694.98l.191.462a7.946 7.946 0 01-2.017.54l-.065-.496a7.578 7.578 0 01-1.96 0l-.065.495a7.946 7.946 0 01-2.017-.539l.191-.462a7.487 7.487 0 01-1.695-.98l-.304.396a8.048 8.048 0 01-1.477-1.477l.396-.304a7.492 7.492 0 01-.98-1.695l-.462.191a7.945 7.945 0 01-.54-2.017l.496-.065a7.575 7.575 0 010-1.96l-.496-.065a7.946 7.946 0 01.54-2.017l.462.191c.252-.61.583-1.178.98-1.695l-.396-.304A8.047 8.047 0 013.97 2.362l.304.396a7.492 7.492 0 011.695-.98l-.191-.462a7.946 7.946 0 012.017-.54l.065.496a7.575 7.575 0 011.96 0l.065-.495a7.945 7.945 0 012.017.539l-.191.462a7.49 7.49 0 011.694.98l.305-.396a8.048 8.048 0 011.477 1.477l-.396.304a7.49 7.49 0 01.98 1.695l.462-.191z","stroke":"#748190","stroke-dasharray":"2 2"}})])
          )
        }
      }
    